'use client';

/**
 * Root error boundary.
 *
 * Tanpa file ini, setiap error saat render membuat Next.js gagal total dan
 * hanya menampilkan "missing required error components, refreshing...".
 * Dengan boundary ini, error ditampilkan sebagai halaman yang rapi dan
 * aplikasi tetap bisa dipakai (bukan blank/500 loop).
 */
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
          Terjadi kesalahan
        </h1>
        <p style={{ fontSize: 14, opacity: 0.75, marginBottom: 20 }}>
          Halaman gagal dimuat. Silakan coba lagi.
        </p>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: '9px 18px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: 14,
            background: 'var(--rd-primary, #E4572E)',
            color: '#fff',
          }}
        >
          Coba lagi
        </button>
      </div>
    </div>
  );
}
